export default "__VITE_ASSET__D0qK06xG__"